import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import { DefeatAllUnitsOfAffiliation, HealPlayerPartyScript, Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript } from "@frog/source/data/plotscripts.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

const tiledWorld = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/tileset.json"),
})

const RED = "#d54b33"
const BLACK = "#000"
const OPENING_NARRATION = `
0.000000	0.000000	if
0.265193	0.265193	god
0.481535	0.481535	sends
0.921198	0.921198	me
1.046816	1.046816	to
1.200349	1.200349	hell
2.149463	2.149463	I
2.282059	2.282059	will
2.372783	2.372783	simply
2.945043	2.945043	not
3.321897	3.321897	go
4.131435	4.131435	what
4.264031	4.264031	will
4.438501	4.438501	he
4.640885	4.640885	do?
5.115442	5.115442	send
5.269062	5.269062	me
5.373744	5.373744	to
5.578425	5.578425	hell??
6.525154	6.525154	i'm
6.627539	6.627539	already
6.950860	6.950860	not
7.027713	7.027713	going
8.065166	8.065166	the
8.383893	8.383893	fuck
`.split("\n").map((line) => {
    if(line == "") return
    const parts = line.split("	")
    return {
        "mark": parseFloat(parts[0]) * 1000,
        "text": parts[2],
    }
}).filter((narration) => !!narration)

export default {
    "slug": "wrath",
    "hasTutorial": true,
    "hasPreparePhase": false,
    "startingEncounter": "1",

    "stage": {
        "image": require("./image.png"),
        "world": tiledWorld,
        "units": require("./units.json"),
        "conditions": [
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "good",
                    })
                },
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => App.game.chapter.restart()},
                ]
            },
            {
                "type": "turn:0:start",
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Opening:Music")},
                    {"func": () => Audiomix.trigger("Hell:Opening:Narration")},
                    {
                        "type": "Dialogue",
                        "deltastages": [
                            ...OPENING_NARRATION.map((narration) => {
                                return {
                                    "mark": narration.mark - 75,
                                    "dialogue": {"type": "banner", "text": narration.text}
                                }
                            }),
                            {
                                "mark": 8600 - 75,
                                "dialogue": {"type": "banner", "data": {"color": BLACK}},
                            },
                            {
                                "mark": 9500 - 75,
                                "dialogue": {"type": "banner", "data": {"color": BLACK}, "text": "HELLWARDS"}
                            },
                            {
                                "mark": 13000 - 75,
                                "dialogue": {"type": "banner", "data": {"color": BLACK}}
                            },
                            {
                                "mark": 14000 - 75,
                                "dialogue": {"type": "banner", "data": {"color": BLACK}, "text": "CHAPTER 1"}
                            },
                            {
                                "mark": 18000 - 75,
                                "dialogue": {"type": "banner", "data": {"color": BLACK}}
                            }
                        ]
                    },
                    {
                        "deltastages": [
                            {
                                "mark": 0,
                                "dialogue": undefined
                            }
                        ]
                    }
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 1,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 2})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 2,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 3})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 3,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 4}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 4,
                    })
                },
                "events": [
                    HealPlayerPartyScript(),
                    MoveEncounterScript({"nextEncounterKey": 5}),
                    {
                        "type": "Dialogue",
                        "deltastages": [
                            {
                                "mark": 500,
                                "unit": {"key": "archdevil", "position": {"x": 8, "y": 5}},
                            },
                            {
                                "mark": 530,
                                "unit": {"key": "archdevil", "position": {"x": 9, "y": 5}},
                            },
                            {
                                "mark": 760,
                                "audio": {"triggerKey": "Hell:Scream"},
                            },
                            {
                                "mark": 760,
                                "unit": {"key": "archdevil", "faceKey": "devilscream"},
                            },
                            {
                                "mark": 1260,
                                "unit": {"key": "archdevil", "faceKey": "devil"},
                            },
                            {
                                "mark": 1260,
                                "func": function() {
                                    App.tutorial.hasSeenBoss = true
                                }
                            },
                        ]
                    }
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return DefeatAllUnitsOfAffiliation({
                        "stage": stage,
                        "affiliation": "bad",
                        "encounterKey": 5,
                    })
                },
                "events": [
                    {"func": () => Audiomix.trigger("Hell:Music:Victory")},
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/games/hell/chapters/avarice")},
                ]
            },
        ]
    },
}
